import { ReactComponent as Logo } from './logo/logo-css.svg';
import {
    AQUA,
    aquaGradient,
    aquaGradientColors,
    blueGradient,
    blueGradientColors,
    goldGradientColors,
    redGradient,
    redGradientColors,
    turquoiseGradient,
    turquoiseGradientColors
} from './colors/colors';
const palette = {
    themeGradient: {
        primary: aquaGradient,
        secondary: aquaGradient
    },
    gradients: {
        primary: aquaGradient,
        secondary: turquoiseGradient,
        info: blueGradient,
        error: redGradient,
        success: aquaGradient
    },
    gradientColors: {
        primary: aquaGradientColors,
        secondary: goldGradientColors,
        success: aquaGradientColors,
        error: redGradientColors,
        info: blueGradientColors,
        warning: turquoiseGradientColors
    },
    primary: {
        lightest: AQUA[50],
        lighter: AQUA[200],
        light: AQUA[400],
        main: AQUA[500],
        dark: AQUA[600],
        shadow: AQUA[100],
        contrastText: '#fafafa',
        contrastGreyText: '#fff'
    },
    borderColor: AQUA[200],
    focusColor: AQUA[50],
    mainSelected: AQUA[100],
    dashboardGradients: [
        {
            start: aquaGradientColors[0],
            end: aquaGradientColors[1]
        },
        {
            start: redGradientColors[0],
            end: redGradientColors[1]
        },
        {
            start: blueGradientColors[0],
            end: blueGradientColors[1]
        },
        {
            start: turquoiseGradientColors[0],
            end: turquoiseGradientColors[1]
        }
    ],
    defaultDashboardGradient: {
        start: aquaGradientColors[0],
        end: aquaGradientColors[1]
    }
};

const hiddenColumns = {
    transactions: ['coinOwnerFee', 'systemFee']
};

const config = {
    title: 'CSS',
    logo: Logo,
    palette,
    allowMerchantRegistration: false,
    allowGoogleAuth: false,
    chartSettings: {
        hiddenFields: ['volumeTransactionsByDate']
    },
    hiddenColumns
};

export default config;
